// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Nunito_Sans_95e723', '__Nunito_Sans_Fallback_95e723'","fontStyle":"normal"},"className":"__className_95e723"};